// Client mirror of the server permission model (functions/_shared/roles.ts).
// UI gating only — the server re-checks every privileged action (never trust
// the client for authorization).

export const STAFF_ROLES = ["super_admin", "admin", "moderator", "support", "staff"] as const;
export type Role = (typeof STAFF_ROLES)[number];

export const PERMISSIONS = {
  manage_roles: ["super_admin"],
  admin_users: ["super_admin", "admin"],
  admin_verification: ["super_admin", "admin", "moderator"],
  admin_moderation: ["super_admin", "admin", "moderator"],
  admin_support: ["super_admin", "admin", "support"],
  admin_feedback: ["super_admin", "admin", "support"],
  admin_security: ["super_admin", "admin"],
} as const;
export type Permission = keyof typeof PERMISSIONS;

export function can(roles: string[], perm: Permission): boolean {
  return (PERMISSIONS[perm] as readonly string[]).some((r) => roles.includes(r));
}

/** Any internal-staff role (gates the staff/admin area). */
export function isStaff(roles: string[]): boolean {
  return roles.some((r) => (STAFF_ROLES as readonly string[]).includes(r));
}

export const ROLE_LABELS: Record<string, string> = {
  super_admin: "Super admin",
  admin: "Admin",
  moderator: "Moderator",
  support: "Support",
  staff: "Staff",
};
